import { Fullscreen } from "@shopify/app-bridge/actions"
import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"

import AppBridge from "@/utils/app-bridge"

interface TempFullBarProps {
  backUrl?: string
}
const TempFullBar = (props: TempFullBarProps) => {
  const { backUrl = "/settings/automation" } = props
  const history = useHistory()
  useEffect(() => {
    if (AppBridge.app()) {
      const unSubscribe = AppBridge.app().subscribe(
        Fullscreen.Action.EXIT,
        () => {
          history.push(backUrl)
          AppBridge.dispatchFullscreen(Fullscreen.Action.ENTER)
        },
      )
      return () => {
        unSubscribe()
      }
    }
  }, [backUrl, history])
  return <></>
}

export default TempFullBar
